import styled from "styled-components";

const BrandText = styled.p`
    font-weight: 700;
`
const TitleText = styled.p`
    font-size: 0.8em;
    color: grey;
`
const PriceText = styled.p`
    font-size: 0.9em;
    font-weight: 600;
`

export {BrandText,TitleText,PriceText}